export enum AlertPreferenceDelayTypeEnum {
  NOTHING = "NOTHING",
  AMOUNT = "AMOUNT",
  DAYS_PASSED = "DAYS_PASSED",
  DAYS_LEFT = "DAYS_LEFT",
  DAYS_EXACTLY = "DAYS_EXACTLY",
}
